import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {DeereCachedFetch, DeereFetch} from '../../../shared/fetch';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import EnhancedTable from '../CollapsibleTable/sortIndex';
import history from '../../../shared/history';
import {EmptyStateLayout} from '../EmptyPage';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import smartlookClient from 'smartlook-client';



export class SelectProposalEsign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dealerNames: [],
            countries: [],
            dealers: [],
            bundleDataForSalesPerson: [],
            dataRows: [],
            primaryCustomers: [],
            quoteNumber: '',
            quoteNumberSearch: '',
            bundleNumberSearch: '',
            icsIdSearch: '',
            primaryCustomer: '',
            search: '',
            showGetStatusSpinner: false,
            noSearchResults: false,
            isAsmOrDro: false,
            hasError: false,
            errorMessage: '',
            initialLoad: true,
            bundlesToShow: new Set()
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleGetStatus = this.handleGetStatus.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.searchHelper = this.searchHelper.bind(this);
        this.getBundleData = this.getBundleData.bind(this);
    }

    async getEnvelopeDetailsForBundles(bundleNumbers, rebuildCache){
        const urls = Array.from(bundleNumbers).map(bundleNumber => '/api/esign/bundle/envelopes/' + bundleNumber)
        const envelopeDetails = await Promise.all(
            urls.map((url) =>
                DeereCachedFetch(url, {
                    cacheDuration: 'forever'
                }, rebuildCache)
            )
        );
        return envelopeDetails.reduce((accumulator, value) => accumulator.concat(value), [])
    }

    async componentDidMount() {
        const bundleData = await this.getBundleData(1);
        smartlookClient.record({ forms: true, numbers: true, emails: false });
        let bundleDataForSalesPerson;
        if (bundleData !== null) {
            //when user is a salesperson
            const allBundleData = [...bundleData.esignProposalDetails]
            const bundlesToShow = new Set(allBundleData.map(data => data.bundleNumber));
            bundleDataForSalesPerson = allBundleData.map(data => {
                return {
                    id: data.agreementNumber,
                    countryCode: data.country,
                    icsID: data.icsId,
                    bundleNumber: data.bundleNumber,
                    quoteNumber: data.agreementNumber,
                    startDate: data.startDate,
                    maturityDate: data.maturityDate,
                    asmName: null,
                    alfaDealerIdentifier: data.thirdPartyDetails[0].thirdPartyNumber,
                    alfaDealerName: data.thirdPartyDetails[0].displayName,
                    alfaCaseStatus: data.alfaCaseStatus,
                    financeProduct: data.financeProduct,
                    salesPersonName: data.salesperson,
                    primaryCustomer: [data.thirdPartyDetails[1] ? data.thirdPartyDetails[1].displayName : ' '],
                    hasGuarantor: data.hasGuarantor,
                    assetInformation: data.scheduleDescription,
                    dealerReference: data.dealerReference,
                    primaryQuote: data.primaryQuote
                }
            })
            this.setState({bundlesToShow});
            let bundleEnvelopes = [];
            bundleEnvelopes = await this.getEnvelopeDetailsForBundles(bundlesToShow, (this.props.location && this.props.location.search))

            /*setting the envelope details of a quote into bundle data*/
            for (const element of bundleDataForSalesPerson) {
                element.envelopes = bundleEnvelopes.filter(bundleEnvelope => bundleEnvelope.envelopeDetail.quoteNumber === element.quoteNumber);
            }
        }

        const query = this.props.location && this.props.location.search;
        const params = new URLSearchParams(query || '');
        const search = params.get('search') || '';
        const bundleNumberSearch = this.props.bundleNumber || '';
        const quoteNumberSearch = this.props.agreementNumber || '';
        const hasInitialSearch = Boolean(query || bundleNumberSearch || quoteNumberSearch);

        if (hasInitialSearch) {
            this.setState({
                search,
                quoteNumber: search,
                bundleNumberSearch,
                quoteNumberSearch
            });
        }

        const primCustomers = bundleDataForSalesPerson && bundleDataForSalesPerson.map(detail => detail.primaryCustomer);
        const primaryCustomerSet = new Set();
        primCustomers && primCustomers.map(primCustomer => primaryCustomerSet.add(primCustomer[0]));

        if (hasInitialSearch) {
            await this.handleSearch({
                bundleNumberSearch,
                quoteNumberSearch,
                icsIdSearch: '',
                primaryCustomer: ''
            });
        } else {
            this.setState({
                dataRows: bundleDataForSalesPerson,
                bundleDataForSalesPerson,
                primaryCustomers: Array.from(primaryCustomerSet)
            });
        }

        if (hasInitialSearch) {
            this.setState({
                bundleDataForSalesPerson,
                primaryCustomers: Array.from(primaryCustomerSet)
            });
        }

    }

    async handleGetStatus(envelopeId, quoteNumber, setSpinnerOn) {

        setSpinnerOn(true);

        const recipientsStatus = await DeereFetch('/api/esign/recipients-status/' + envelopeId);
        const envelopeStatus = await DeereFetch('/api/esign/envelope-status/' + envelopeId);

        const dataRows = JSON.parse(JSON.stringify(this.state.dataRows));
        const quotes = dataRows.find(o => o.quoteNumber === quoteNumber);
        const envelopes = quotes.envelopes;
        const envelope = envelopes.find(o => o.envelopeDetail.envelopeId === envelopeId);

        envelope.envelopeDetail.lastModifiedAt = envelopeStatus.LastModifiedDate;
        envelope.envelopeDetail.status = envelopeStatus.Status;

        envelope.envelopeDetail.signers.forEach(signer => {

            const recipientStatus = recipientsStatus.filter(recipient => recipient.recipientId === signer.recipientId);
            if (recipientStatus !== null && recipientStatus.length > 0) {
                signer.status = recipientStatus[0].status;
                signer.envelopeDeclinedDate = recipientStatus[0].envelopeDeclinedDate;
                signer.envelopeDeclinedReason = recipientStatus[0].envelopeDeclinedReason;
                signer.envelopeViewedDate = recipientStatus[0].envelopeViewedDate;
                signer.envelopeSentDate = recipientStatus[0].envelopeSentDate;
                signer.envelopeSignedDate = recipientStatus[0].envelopeSignedDate;
            }

        })

        const bundleData = JSON.parse(JSON.stringify(this.state.dataRows));
        const salespersonQuotes = bundleData.filter(eSignProposal => eSignProposal.quoteNumber === quoteNumber);
        salespersonQuotes[0].envelopes = quotes.envelopes;

        this.setState({dataRows, bundleData});
        setSpinnerOn(false);
    }

    async getBundleData(pageNum) {
        const user = this.props.user;
        if (user.branchCode.includes('SP')) {
            return DeereCachedFetch('/api/esign/bundles-list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    userId: user.id,
                    pageNumber: pageNum,
                    branchCode: user.branchCode
                })
            });
        }
        this.setState({
            isAsmOrDro: true
        })
        return null;
    }

    handleChange(name) {
        return (e) => {
            this.setState({
                [name]: e.target.value
            });
        };
    }

    handleClear() {
        history.push('/e-sign');
        this.setState((prevState) => ({
            bundleNumberSearch: '',
            icsIdSearch: '',
            primaryCustomer: '',
            noSearchResults: false,
            hasError: false,
            initialLoad: true,
            dataRows: prevState.bundleDataForSalesPerson,
            quoteNumber: '',
            quoteNumberSearch: ''
        }))
    }

    searchHelper(searchCriteria) {
        const [data, fieldName, searchField] = searchCriteria;

        return data.filter(dataRow => dataRow[fieldName] === searchField);
    }

    async handleSearch(searchCriteria) {
        const criteria = searchCriteria && Object.prototype.hasOwnProperty.call(searchCriteria, 'quoteNumberSearch')
            ? searchCriteria
            : this.state;
        const user = this.props.user;
        this.setState({
            initialLoad: false,
            hasError: false,
            dataRows: []
        })
        try {
            const searchedData = await DeereCachedFetch('/api/esign/bundle-search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    userId: user.id,
                    bundleNumber: criteria.bundleNumberSearch || null,
                    agreementNumber: criteria.quoteNumberSearch || null,
                    icsReference: criteria.icsIdSearch || null,
                    customer: criteria.primaryCustomer || null
                })
            })

            if (searchedData.esignProposalDetails === null || searchedData.esignProposalDetails.length === 0) {
                this.setState({
                    noSearchResults: true
                })
            } else {
                const allBundleData = [...searchedData.esignProposalDetails]
                const bundlesToShow = new Set(allBundleData.map(data => data.bundleNumber));
                const bundleDataForSalesPerson = allBundleData.map(data => {
                    return {
                        id: data.agreementNumber,
                        countryCode: data.country,
                        icsID: data.icsId,
                        bundleNumber: data.bundleNumber,
                        quoteNumber: data.agreementNumber,
                        startDate: data.startDate,
                        maturityDate: data.maturityDate,
                        asmName: null,
                        alfaDealerIdentifier: data.thirdPartyDetails[0].thirdPartyNumber,
                        alfaDealerName: data.thirdPartyDetails[0].displayName,
                        alfaCaseStatus: data.alfaCaseStatus,
                        financeProduct: data.financeProduct,
                        salesPersonName: data.salesperson,
                        primaryCustomer: [data.thirdPartyDetails[1] ? data.thirdPartyDetails[1].displayName : ' '],
                        hasGuarantor: data.hasGuarantor,
                        assetInformation: data.scheduleDescription,
                        dealerReference: data.dealerReference,
                        primaryQuote: data.primaryQuote
                    }
                })
                this.setState({bundlesToShow});

                let bundleEnvelopes = [];
                bundleEnvelopes = await this.getEnvelopeDetailsForBundles(bundlesToShow, this.props.location && this.props.location.search)

                for (const element of bundleDataForSalesPerson) {
                    element.envelopes = bundleEnvelopes.filter(bundleEnvelope => bundleEnvelope.envelopeDetail.quoteNumber === element.quoteNumber);
                }

                this.setState({
                    dataRows: bundleDataForSalesPerson,
                    noSearchResults: bundleDataForSalesPerson === null || bundleDataForSalesPerson === undefined
                })
            }

        } catch (e) {
            this.setState({
                hasError: true,
                errorMessage: e.errorMessage
            })
        }
    }

    render() {
        const isEmptyResultShown = this.state.isAsmOrDro && this.state.initialLoad;
        const componentMap = {
            [!this.state.noSearchResults]: <EnhancedTable handleGetStatus={this.handleGetStatus} order={'desc'}
                orderBy={'startDate'}
                rows={this.state.dataRows}
                userBranchCode={this.props.user.branchCode}
                userHasAccessToERegistry={this.props.user.hasAccessToERegistry}
            />,
            [this.state.noSearchResults && this.state.isAsmOrDro]: <EmptyStateLayout
                context={<FormattedMessage id={'alerts.NO_RESULTS_FOUND'}/>}
                message={<FormattedMessage id={'alerts.NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA'}/>}/>,
            [this.state.noSearchResults && !this.state.isAsmOrDro]: <EmptyStateLayout
                context={<FormattedMessage id={'alerts.NO_RESULTS_FOUND'}/>}
                message={<FormattedMessage
                    id={'alerts.NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR'}/>}/>,
            [isEmptyResultShown]: <EmptyStateLayout
                context={<FormattedMessage id={'alerts.SEARCH_FOR_A_PROPOSAL_TO_CONTINUE'}/>}/>,
            [this.state.hasError]: <EmptyStateLayout context={<FormattedMessage id={this.state.errorMessage}/>}/>
        }

        return (

            <div>
                <h3 className="mb-2">
                    <FormattedMessage id={'labels.E_SIGNATURE_DASHBOARD'}/>
                </h3>
                <Card style={{marginBottom: 20}}>
                    <CardContent>
                        <Grid container direction="row" item spacing={2} style={{marginLeft: '2%'}}>
                            <Grid alignItems="flex-start" container direction="column" item
                                justifyContent="space-between" sm={3}
                                xs={6}>
                                <Typography style={{fontWeight: 'bold'}}>
                                    <FormattedMessage id={'labels.BUNDLE'}/>
                                </Typography>
                                <TextField
                                    disabled={false}
                                    id="bundle-number"
                                    margin="none"
                                    onChange={this.handleChange('bundleNumberSearch')}
                                    placeholder="B001234"
                                    value={this.state.bundleNumberSearch}
                                />
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item
                                justifyContent="space-between" sm={3}
                                xs={6}>
                                <Typography style={{fontWeight: 'bold'}}>
                                    <FormattedMessage id={'labels.QUOTE'}/>
                                </Typography>
                                <TextField
                                    disabled={false}
                                    id="quote-number"
                                    margin="none"
                                    onChange={this.handleChange('quoteNumberSearch')}
                                    placeholder="AALF001234"
                                    value={this.state.quoteNumberSearch}
                                />
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item
                                justifyContent="space-between" sm={3}
                                xs={6}>
                                <Typography style={{fontWeight: 'bold'}}>
                                    <FormattedMessage id={'labels.ICS_REFERENCE'}/>
                                </Typography>
                                <TextField
                                    disabled={false}
                                    id="ics-reference"
                                    margin="none"
                                    onChange={this.handleChange('icsIdSearch')}
                                    placeholder="123456"
                                    value={this.state.icsIdSearch}
                                />
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item
                                justifyContent="space-between" sm={3}
                                xs={6}>
                                <Typography style={{fontWeight: 'bold'}}>
                                    <FormattedMessage id={'labels.PRIMARY_CUSTOMER'}/>
                                </Typography>
                                <TextField
                                    disabled={false}
                                    id="primaryCustomer"
                                    margin="none"
                                    onChange={this.handleChange('primaryCustomer')}
                                    placeholder="David Smith"
                                    value={this.state.primaryCustomer}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid alignItems="center" container direction="row" justifyContent="flex-end"
                    style={{marginBottom: 20}}>
                    <div style={{position: 'relative', marginLeft: 10}}>
                        <Button
                            color="default"
                            disabled={this.state.loading}
                            onClick={this.handleClear}
                            style={{marginLeft: 10}}
                            variant="contained"
                        >
                            <FormattedMessage id={'labels.CLEAR'}/>
                        </Button>
                        <Button
                            disabled={this.state.loading}
                            onClick={this.handleSearch}
                            style={{marginLeft: 10, backgroundColor: '#ffde00'}}
                            variant="contained"
                        >
                            <FormattedMessage id={'labels.SEARCH'}/>
                        </Button>

                        {this.state.loading && <CircularProgress disableShrink size={24} style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: -12,
                            marginLeft: -12
                        }}/>}
                    </div>
                </Grid>
                {componentMap.true}
            </div>

        );
    }
}

SelectProposalEsign.propTypes = {
    location: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    bundleNumber: PropTypes.string,
    agreementNumber: PropTypes.string
}
